import { Component, Input, ViewEncapsulation } from '@angular/core';

// Componente gestione espansione
@Component({
    selector: '[s1-expandable-row]',
    templateUrl: './s1-expandable-row.component.html',
    styleUrls: ['./s1-expandable-row.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class S1ExpandableRow {

  @Input() expanded: boolean = false

  constructor() { }

}

// Componente contenuto espandibile
@Component({
    selector: '[s1-expandable-row-content]',
    template: '@if (master?.expanded) {<ng-content></ng-content>}',
    standalone: false
})
export class S1ExpandableRowContent {

  @Input() master: S1ExpandableRow;

  constructor() { }

} 
